module.exports = __webpack_public_path__ + "img/GH-kyujin-top-024.66746613.webp";